import { render, staticRenderFns } from "./model-renewal.vue?vue&type=template&id=5c2b4787&scoped=true&"
import script from "./model-renewal.vue?vue&type=script&lang=js&"
export * from "./model-renewal.vue?vue&type=script&lang=js&"
import style0 from "./model-renewal.vue?vue&type=style&index=0&id=5c2b4787&scoped=true&lang=less&"
import style1 from "./model-renewal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b4787",
  null
  
)

export default component.exports